import { useEffect, useState } from "react"
import { Layout } from "components/common"
import BoxRelatedToChanel from "components/BoxRelatedToChanel"
import { apiChannel } from "api"
import config from "lib/config"
import fetchWithTimeout from "api/fetchWithTimeout"
import ViewPlay from "components/ViewPlay"
import Image from "next/legacy/image"
import cn from "classnames"
import HeaderPage from "components/HeaderPage"
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { useRef } from "react"
import TagPremium from "components/TagPremium"
import { trackGA } from "lib/func"
import { detectPlatform } from "utils/helper"

const Share = dynamic(() => import("components/Share"), { ssr: false })

export default function Channel({ query, initVideo, platform }) {
  // console.log({ error })
  const router = useRouter()
  const [videoPlay, setVideoPlay] = useState({ ...initVideo, channel: initVideo?.channel || { name: initVideo?.name } })
  const [channels, setChanel] = useState([])
  const [topics, setTopics] = useState([])
  const [topicId, setTopicId] = useState()
  const __init = useRef({ ...initVideo, channel: initVideo?.channel || { name: initVideo?.name } })
  async function getChannels(topic_id) {
    try {
      const { data } = await apiChannel.getChannels({ event_id: query?.id, topic_id })
      setChanel(data)
    } catch (error) {
      console.log(error)
    }
  }
  async function getTopics() {
    try {
      const { data } = await apiChannel.getTopics()
      setTopics([{ id: undefined, name: "Tất cả" }, ...data])
    } catch (error) {
      console.log(error)
    }
  }
  function onChangeTopic(v) {
    setTopicId(v)
    getChannels(v)
  }

  function onChangePlay(v) {
    if (v && initVideo?.id && v?.url) {
      // console.log({ v })
      setVideoPlay(v)
    } else {
      setVideoPlay(__init.current)
    }
  }

  useEffect(() => {
    getChannels()
    getTopics()
  }, [])

  useEffect(() => {
    const enriched = {
      ...initVideo,
      channel: { name: initVideo?.name }
    }
    __init.current = enriched
    setVideoPlay(enriched)
    trackGA(initVideo?.name, "CHANNEL_VIDEO")
    trackGA(initVideo?.name, "ChannelDetailVC")
  }, [initVideo])

  const { channel, title, synopsis } = videoPlay
  // console.log("urlurlurlurlurl", videoPlay?.url)
  return (
    <section className="max-w-screen-xl m-auto">
      <div>
        <HeaderPage initVideo={initVideo} query={query} />
      </div>
      <div className="mb-16 pt-10 px-8">
        <div className="lg:grid grid-cols-3 xl:grid-cols-10 gap-4 mb-6">
          <div className="col-span-2 xl:col-span-7 mb-4 ">
            <ViewPlay initVideo={videoPlay} />
            <div className="lg:text-2xl mt-4 mb-2 text-dark-100 font-semibold text-xl">{channel?.name}</div>
            <div className="flex justify-between items-center gap-4">
              <div className="text-dark-300 md:text-base text-sm">
                {title} {synopsis}
              </div>

              <Share id={initVideo?.id} />
            </div>
          </div>
          <div className="grid-cols-1 xl:col-span-3">
            <BoxRelatedToChanel event_id={query?.id} platform={platform} onChangePlay={onChangePlay} />
          </div>
        </div>
        <div>
          <div className="border-b border-gray-500 font-medium lg:text-xl text-dark-100 mb-4 pb-2 text-lg">
            DANH SÁCH KÊNH
          </div>
          <div className="flex gap-4 flex-wrap mb-6">
            {topics?.map(({ id, name }, k) => {
              const __class = topicId === id ? "bg-primary-500 text-dark-800 font-medium" : "bg-white/20 text-dark-100"
              return (
                <button
                  key={k}
                  className={cn("px-3 py-2 hover:text-blue-600 rounded", __class)}
                  onClick={() => onChangeTopic(id)}
                >
                  {name}
                </button>
              )
            })}
          </div>

          <div className="gap-4 grid md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 grid-cols-2">
            {channels?.map(({ thumbnail, id, is_premium, name, package_type }) => {
              const __class = query?.id === id ? "border-blue-400 rounded-[11px]" : "border-transparent rounded-[12px]"
              return (
                <div key={id} className="col-span-1 mb-4" onClick={() => router.push(`/channel?id=${id}`)}>
                  <CardChannel
                    __class={__class}
                    is_premium={is_premium}
                    thumbnail={thumbnail}
                    name={name}
                    package_type={package_type}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </section>
  )
}

Channel.Layout = Layout

function CardChannel({ __class, thumbnail, is_premium, name, package_type }) {
  const [srcImage, setSrcImage] = useState(thumbnail)
  return (
    <>
      <div className={cn("rounded-lg cursor-pointer border-[3px] relative", __class)}>
        <div className="fix_img rounded">
          <Image
            height={153}
            width={274.5}
            className="rounded-lg"
            src={srcImage}
            onError={() => setSrcImage("https://stvinaprod.vtvcab.vn/4ab5f0e3-d616-4834-9485-d54b0ebb7115.png")}
          />
        </div>
        {/* {is_premium && (
          <div
            className="absolute text-dark shadow top-2 left-2 bg-premium font-semibold rounded flex  items-center px-1 py-0.5"
            style={{ fontSize: "5px" }}
          >
            {iconPre} &nbsp;<div>PREMIUM</div>
          </div>
        )}  */}
        <TagPremium package_type={package_type} />
      </div>
      <div className="line-clamp-1 text-sm mt-2 bottom-0 left-0 w-full text-dark-100">{name}</div>
    </>
  )
}

export async function getServerSideProps({ query, req }) {
  let initVideo = {},
    error = {}

  let platform = "widevine"

  try {
    const userAgent = req.headers["user-agent"] || ""
    platform = detectPlatform(userAgent)

    const params = {
      ...query,
      platform,
      type: 1
    }

    const response = await fetchWithTimeout(`${config.BASE_API_URL}/publish/event/?` + new URLSearchParams(params))
    const res = await response?.json()
    if (response?.ok) {
      if (res?.data) initVideo = res?.data
    } else {
      error = res
      // error.error_code = 412
      console.log("API - Get channel or channel: ", res)
    }
  } catch (error) {
    console.log(error)
  }
  if (error?.error_code) initVideo.error = error

  return {
    props: {
      initVideo,
      query,
      platform
    }
  }
}

const iconPre = (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.45681 3.36076L4.10856 0.709007C4.24931 0.568257 4.44006 0.489258 4.63881 0.489258C4.83781 0.489258 5.02856 0.568257 5.16931 0.709007C5.71256 1.25251 6.74706 2.28701 7.29056 2.83026C7.43131 2.97101 7.51031 3.16176 7.51031 3.36076C7.51031 3.55951 7.43106 3.75026 7.29056 3.89101L4.63881 6.54276L4.10856 6.01226C4.01106 5.91476 3.85256 5.91476 3.75506 6.01226C3.65731 6.11001 3.65731 6.26826 3.75506 6.36576L4.28531 6.89626L3.90956 7.27201C3.76881 7.41276 3.57806 7.49176 3.37906 7.49176C3.18031 7.49176 2.98956 7.41276 2.84881 7.27201C2.57906 7.00226 2.25331 6.67651 2.25331 6.67651C2.15556 6.57901 2.15556 6.42051 2.25331 6.32301C2.25331 6.32301 2.32106 6.25526 2.41106 6.16526C2.48281 6.09351 2.52306 5.99626 2.52306 5.89476C2.52306 5.79326 2.48281 5.69601 2.41106 5.62426C2.41106 5.62401 2.41081 5.62401 2.41081 5.62376C2.33906 5.55201 2.24156 5.51176 2.14031 5.51176C2.03881 5.51176 1.94156 5.55201 1.86981 5.62376C1.77956 5.71401 1.71181 5.78151 1.71181 5.78151C1.61431 5.87926 1.45606 5.87926 1.35831 5.78151C1.35831 5.78151 1.00981 5.43301 0.727562 5.15076C0.586812 5.01001 0.507812 4.81926 0.507812 4.62051C0.507812 4.42151 0.586812 4.23076 0.727562 4.09001L1.10331 3.71426L1.63356 4.24451C1.73131 4.34201 1.88956 4.34201 1.98731 4.24451C2.08481 4.14701 2.08481 3.98851 1.98731 3.89101L1.45681 3.36076ZM4.40681 2.78001L4.89306 2.43026C4.96881 2.37551 5.06906 2.36776 5.15256 2.41026C5.23581 2.45276 5.28856 2.53826 5.28906 2.63201L5.29181 3.23076L5.77456 3.58501C5.85006 3.64051 5.88831 3.73326 5.87356 3.82576C5.85906 3.91826 5.79406 3.99476 5.70506 4.02401L5.13631 4.21176L4.94856 4.78051C4.91931 4.86926 4.84281 4.93426 4.75031 4.94901C4.65781 4.96351 4.56506 4.92551 4.50981 4.85001L4.15531 4.36701L3.55656 4.36426C3.46306 4.36376 3.37756 4.31126 3.33506 4.22776C3.29256 4.14451 3.30006 4.04426 3.35481 3.96826L3.70456 3.48226L3.52206 2.91176C3.49356 2.82251 3.51731 2.72501 3.58356 2.65876C3.64956 2.59276 3.74731 2.56901 3.83631 2.59751L4.40681 2.78001Z"
      fill="#000E2B"
    />
  </svg>
)
